import React from 'react'
import { withStyles } from '@material-ui/core'
import styles from './styles'
import { Sections } from './components'
import { useSelector } from 'react-redux'
import clsx from 'clsx'
const CourseLeftSide = props => {
  const { classes, sections, setSections } = props
  const open = useSelector(state => state.course.sectionDrawerOpen)

  return (
    <div
      className={clsx({
        [classes.courseLeftSideRoot]: !open,
        [classes.courseLeftSideRootOpen]: open,
      })}
    >
      <Sections sections={sections} setSections={setSections} />
    </div>
  )
}

export default withStyles(styles)(CourseLeftSide)
